export default "__VITE_ASSET__BWrQOIa7__"